import * as React from 'react';
import { useEffect } from 'react';
import { observer } from 'mobx-react';
import { useParams } from 'react-router-dom';
import SecuredPage from 'Views/Components/Security/SecuredPage';

import NavigationWrapper from '../Components/Navigation/NavigationWrapper';
import { BOOKINGS_CUSTOMER_PAGE_TITLE } from 'ConstantPageNames';
import { BookingDetailedView } from '../Components/_HumanWritten/Bookings/BookingDetailedView/BookingDetailedView';

function BookingDetailPage() {
	const { id } = useParams<{ id: string }>();

	useEffect(() => {
		document.title = BOOKINGS_CUSTOMER_PAGE_TITLE;
	}, []);

	return (
		<SecuredPage
			groups={[
				'Super Administrators',
				'User',
				'Staff',
				'Manager',
				'Admin',
				'InvoicedUser',
				'FixedPriceUser',
				'Guest',
			]}
		>
			<NavigationWrapper />
			<div className="body-content">
				<BookingDetailedView bookingId={id!} />
			</div>
		</SecuredPage>
	);
}

export default observer(BookingDetailPage);
